import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import logo from '../../assets/logo.png';

const OtpPage = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [timer, setTimer] = useState(40);
  const { state } = useLocation();
  const email = state?.email || "pratik2hgv@gmail.com";
  const navigate = useNavigate();
  const inputsRef = useRef([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    // Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  
  const handleKeyDown = (e, index) => {
    // On backspace, move to previous input
    if (e.key === "Backspace" && !otp[index] && inputsRef.current[index - 1]) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    console.log("Entered OTP:", enteredOtp);
    // Handle OTP verification logic
    // navigate('/auth/reset-password');
  };

  return (
    <div className="flex flex-col md:flex-row w-full min-h-screen bg-white" dir="rtl">
      {/* Left side decorative image */}
      <div className="hidden md:flex w-1/2 items-center justify-center" style={{ background: 'var(--Primary-Primary)' }}>
        <img
          src={'../Forgotyourpassword.png'}
          alt="Security"
          className="w-1/2"
        />
      </div>

      {/* Right side form */}
      <div className="w-full md:w-1/2 bg-gray-50 flex flex-col items-center justify-center p-8">
        <div className="max-w-md w-full">
          <div className="flex justify-between items-center mb-8">
            <img src={logo} alt="Logo" className="h-10" />
            <Link to="/auth/login" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[var(--Primary-Primary)]">
              رجوع
              <ChevronRight size={20} className="transform rotate-180" />
            </Link>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-center mb-2 text-[#1D2035]">رمز التحقق</h2>
            <p className="text-center text-gray-500 mb-4 text-sm">
              لقد أرسلنا رمز OTP إلى {email} لعملية التحقق.
            </p>
            <p className="text-center font-semibold text-lg text-gray-800 mb-6">
              00:{timer.toString().padStart(2, '0')}
            </p>
            
            {/* Progress Bar */}
            <div className="flex items-center justify-center my-8">
                <div className="w-1/3 h-1 bg-[var(--Primary-Primary)] rounded-full"></div>
                <div className="w-1/3 h-1 bg-[var(--Primary-Primary)] rounded-full"></div>
                <div className="w-1/3 h-1 bg-gray-200 rounded-full"></div>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="flex justify-center gap-2 mb-6" dir="ltr">
                {otp.map((data, index) => {
                  return (
                    <input
                      className="w-12 h-12 text-center text-lg font-semibold border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--Primary-Primary)]"
                      type="text"
                      name="otp"
                      maxLength="1"
                      key={index}
                      value={data}
                      onChange={e => handleChange(e.target, index)}
                      onFocus={e => e.target.select()}
                      onKeyDown={e => handleKeyDown(e, index)}
                      ref={el => inputsRef.current[index] = el}
                    />
                  );
                })}
              </div>
              
              <button
                type="submit"
                className="w-full text-white py-3 rounded-md bg-[var(--Primary-Primary)] hover:bg-opacity-90 transition-colors duration-300 font-semibold"
              >
                استمر
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpPage;
